import { ApiNearbyCommunityType, NearbyCommunityType } from "@/types";

export function normalizeNearbyCommunity(
  community: ApiNearbyCommunityType
): NearbyCommunityType {
  return {
    minMarketingRent: community.min_marketing_rent,
    maxMarketingRent: community.max_marketing_rent,
    minSqft: community.min_sqft,
    maxSqft: community.max_sqft,
    numberOfTourableUnits: community.number_of_tourable_units,
    propertyImageUrl: community.property_image_url,
    tourConfigUuid: community.tour_config_uuid,
    propertyName: community.property_name,
    distance: Number(community.distance.toFixed(1)),
    property: {
      id: community.property.id,
      name: community.property.name,
      streetAddress1: community.property.street_address_1,
      streetAddress2: community.property.street_address_2,
      city: community.property.city,
      state: community.property.state,
      zip: community.property.zip,
      lat: community.property.lat,
      lng: community.property.lng,
      petsAllowed: community.property.pets_allowed,
      petPolicyNotes: community.property.pet_policy_notes,
    },
  };
}
